import React from 'react';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import FilterListIcon from '@mui/icons-material/FilterList';
import Tooltip from '@mui/material/Tooltip';
import {
  gridFilterModelSelector,
  useGridApiContext,
  useGridSelector,
  ColumnsPanelTrigger,
  FilterPanelTrigger,
  ToolbarButton,
  Toolbar,
} from '@mui/x-data-grid-premium';

// NOTE: Ideally, this should come from the theme, but it's a bit messy right now, so I'm keeping it here for now.
const DATA_GRID_TOOLBAR_BASE_COLOR = '#494949';
const DATA_GRID_TOOLBAR_HOVER_COLOR = '#f1f1f1';
const DATA_GRID_TOOLBAR_ACCENT_COLOR = '#1e90ff';

export const DataGridCustomToolbar = ({
  renderCustomToolbar,
  customToolbarFromProps: CustomToolbarFromProps,
  apiRef: apiRefProp,
}) => {
  // Use context apiRef if available, fallback to prop
  let apiRefFromContext;
  try {
    apiRefFromContext = useGridApiContext();
  } catch (e) {
    // Context not available
    apiRefFromContext = null;
  }
  const apiRef = apiRefFromContext || apiRefProp;

  // Use useGridSelector to safely access filter state with fallback
  let filterModel = null;
  try {
    if (apiRef?.current) {
      filterModel = useGridSelector(apiRef, gridFilterModelSelector);
    }
  } catch (e) {
    // Grid not initialized yet
    filterModel = null;
  }
  const filtersApplied = filterModel?.items?.length > 0;

  const clearFilters = () => {
    if (apiRef?.current) {
      apiRef.current.setFilterModel({ items: [] });
    }
  };

  return (
    <div className="datagrid-custom-toolbar">
      <Toolbar
        sx={{
          p: 0,
          justifyContent: 'space-between',
          borderBottom: 'none',
          '.MuiSvgIcon-root': {
            color: DATA_GRID_TOOLBAR_BASE_COLOR,
          },
          '.MuiButtonBase-root': {
            color: DATA_GRID_TOOLBAR_BASE_COLOR,
          },
          '.MuiBadge-root': {
            '& .MuiBadge-badge': {
              backgroundColor: DATA_GRID_TOOLBAR_ACCENT_COLOR,
            },
          },
        }}
      >
        <div>
          <Tooltip title="Columns">
            <ColumnsPanelTrigger render={<ToolbarButton />}>
              <ViewColumnIcon />
            </ColumnsPanelTrigger>
          </Tooltip>

          <Tooltip title="Filters">
            <FilterPanelTrigger render={<ToolbarButton />}>
              <FilterListIcon />
            </FilterPanelTrigger>
          </Tooltip>

          {filtersApplied && (
            <Button
              color="primary"
              startIcon={<CloseIcon />}
              variant="outlined"
              sx={{
                marginLeft: '8px',
                borderColor: DATA_GRID_TOOLBAR_BASE_COLOR,
                '&:hover': {
                  borderColor: DATA_GRID_TOOLBAR_BASE_COLOR,
                  backgroundColor: DATA_GRID_TOOLBAR_HOVER_COLOR,
                },
              }}
              onClick={() => clearFilters()}
            >
              Clear Filters
            </Button>
          )}
        </div>

        {CustomToolbarFromProps && <CustomToolbarFromProps />}
        {renderCustomToolbar && renderCustomToolbar()}
      </Toolbar>
    </div>
  );
};
